import { isTrackReference } from "@livekit/components-core";
import { Track } from "livekit-client";

export function isScreenShareTrackRef(track) {
  if (!isTrackReference(track)) {
    return false;
  }
  return (
    track.source === Track.Source.ScreenShare ||
    track.publication?.source === Track.Source.ScreenShare
  );
}

export function getRemoteScreenShareTrack(tracks) {
  return tracks.find(
    (track) => isScreenShareTrackRef(track) && !track.participant.isLocal && Boolean(track.publication?.trackSid),
  );
}
